import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { errorToastMessage } from "../../../utils/toast";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { sendAiQuery } from "../../../Redux/actions/aiSearchAction";
import { setAiTabType } from "../../../Redux/reducers/aiSearchSlice";
import { useAppDispatch } from "../../../Redux/hooks";

const HistoryTab = () => {
  const [loadingId, setLoadingId] = useState("");
  const [loading, setLoading] = useState(true);
  const [historyData, setHistoryData] = useState<any>([]);
  const { id: studyId } = useParams();

  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res: AxiosResponse = await http.get(`/ai-query`);
        const resData = res?.data?.data;

        const newData = resData?.map((item: any) => ({
          id: item?.id,
          query: item?.userInput,
          time:
            item?.createdAt &&
            DateTime.fromISO(item?.createdAt).toFormat("EEE, dd yyyy  h:mm a"),
          favourite: item?.favourite,
        }));

        setHistoryData(newData || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [studyId, setLoading]);

  const handleRerun = (query: string) => {
    dispatch(sendAiQuery(query));
    dispatch(setAiTabType("aiSearch"));
  };

  const exportParticipants = async (id: string) => {
    try {
      setLoadingId(id);
      let httpUrl = `/ai-query/execute/${id}/export`;
      const res = await http.get(httpUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `ai-query-results-${new Date().getTime()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setLoadingId("");
    }
  };

  return !loading ? (
    <>
      {historyData?.length > 0 ? (
        historyData?.map((item: any) => (
          <Box
            key={item?.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            py={2}
            borderBottom="1px solid #E5E7EB"
          >
            <Box flex={1}>
              <Typography
                variant="body1"
                fontWeight="regular"
                color="text.primary"
                mb={1}
              >
                {item?.query || "-"}
              </Typography>
              <Typography variant="body2" fontWeight="regular" color="#3F83F8">
                {item?.time || "-"}
              </Typography>
            </Box>

            {loadingId === item.id ? (
              <Box sx={{ mr: 2 }}>
                <CircularProgress size={18} />
              </Box>
            ) : (
              <Button
                variant="outlined"
                sx={{ mr: 2 }}
                disabled={!!loadingId}
                onClick={() => exportParticipants(item?.id)}
              >
                Export
              </Button>
            )}

            <Button variant="outlined" onClick={() => handleRerun(item?.query)}>
              Rerun
            </Button>
          </Box>
        ))
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 5,
          }}
        >
          No Search History Available
        </Box>
      )}
    </>
  ) : (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress size={25} />
    </Box>
  );
};

export default HistoryTab;
